export const blockIconsSocialSentimentSatisfiedNew = (
	<span className='material-symbols-outlined'>sentiment_satisfied</span>
);
